import React from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { CREATE_PRODUCT, UPDATE_PRODUCT } from 'pages/Products/ProductsGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import {
  getProductInitialValues,
  productInitialValues,
  productValidationSchema,
} from 'pages/Products/constant';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import AddEditProductForm from './components/AddEditProductForm';

const AddEditProduct = ({ toggleAddRecord, currentRow, type }) => {
  const [createProduct] = useMutation(CREATE_PRODUCT, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.createProduct);
      toggleAddRecord();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateProduct] = useMutation(UPDATE_PRODUCT, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.updateProduct);
      toggleAddRecord();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const handleSubmit = async (values) => {
    if (type === ADD_EDIT_CONSTANT.EDIT) {
      try {
        await updateProduct({
          variables: {
            product: {
              name: values.name,
              status: values.status,
              id: values.id,
              category: values?.category?.id,
              photo: [values.photo],
              document: [values.document],
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    } else {
      try {
        await createProduct({
          variables: {
            product: {
              name: values.name,
              status: values.status,
              category: values?.category?.id,
              photo: [values.photo],
              document: [values.document],
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    }
  };
  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? getProductInitialValues(currentRow)
              : productInitialValues
          }
          enableReinitialize
          validationSchema={productValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditProductForm
                toggleAddRecord={toggleAddRecord}
                {...props}
                type={type}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditProduct;
